import { memo } from 'react';

import { ShareDesignFontRow } from '~/components/ShareModal/components/ShareDesignFontRow';
import { useShareBoardDesign } from '~/components/SharePrivateBoardModal/ShareBoardDesignProvider';

/** "Headline font" row, bound to the board design context. */
export const ShareBoardDesignHeadlineFontRow = memo(() => {
  const {
    brandFonts,
    customTypographyEnabled,
    fontFamily,
    fontVariant,
    handleChangeFont,
    handleClearFont,
    handleFontPopoverOpenChange,
    handleSelectBrandFont,
    selectedBrandFontId,
    typographyDisabled,
  } = useShareBoardDesign();

  return (
    <ShareDesignFontRow
      brandFonts={brandFonts}
      data-testid="SHARE_BOARD_DESIGN_FONT_ROW"
      disabled={typographyDisabled}
      fontFamily={fontFamily}
      label="Headline font"
      onChange={handleChangeFont}
      onClear={handleClearFont}
      onOpenChange={handleFontPopoverOpenChange}
      onSelectBrandFont={handleSelectBrandFont}
      selectedBrandFontId={selectedBrandFontId}
      // Plan-gate-only (typography, not designSettings): the upsell affordance must reflect
      // ONLY the plan gate so it doesn't flash on every save.
      showUpsell={!customTypographyEnabled}
      variant={fontVariant}
    />
  );
});

ShareBoardDesignHeadlineFontRow.displayName = 'ShareBoardDesignHeadlineFontRow';
